import classNames from 'classnames';
import React, { ChangeEvent } from 'react';
import { v4 as uuid } from 'uuid';

import { Label } from '@eika/label';

import { CheckBoxPanelOptionProps } from './types';

const CheckboxPanelOption: React.FC<CheckBoxPanelOptionProps> = ({
    checked,
    label,
    value,
    onValueChange,
    onChange,
    id,
    ref,
    description,
    labels,
    ...rest
}) => {
    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (onChange) onChange(e);
        if (onValueChange) onValueChange(e.target.checked, e.target.value);
    };
    return (
        <label
            className={classNames('sgw-checkbox-panel-option', {
                'sgw-checkbox-panel-option__checked': checked,
            })}
        >
            {labels && (
                <span className="sgw-checkbox-panel-option__label-wrapper">
                    {labels.map(({ type = 'info', ...label }) => (
                        <Label key={label.id ?? uuid()} type={type} {...label} />
                    ))}
                </span>
            )}
            <span className="sgw-checkbox">
                <input
                    type="checkbox"
                    value={value}
                    checked={checked}
                    onChange={onInputChange}
                    id={id}
                    ref={ref}
                    {...rest}
                />
            </span>
            {typeof label === 'string' ? (
                <span className="sgw-checkbox__label sgw-checkbox__label--text">{label}</span>
            ) : (
                <div className="sgw-checkbox__label">{label}</div>
            )}
            {description && <span className="sgw-checkbox-panel-option-description">{description}</span>}
        </label>
    );
};

export default CheckboxPanelOption;
